<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="eGiftPromoCodes"
	[paginator]="eGiftPromoCodes && eGiftPromoCodes.length > 10"
	[rows]="10"
	[showCurrentPageReport]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[10, 25, 50]"
	[globalFilterFields]="['promoCode']"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-fill me-2">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search by promo code</label>
				</span>
			</div>
			<p-button pRipple styleClass="p-button-raised  m-2" (click)="newPromoCode()">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<th>Code</th>
			<th>Discount Value</th>
			<th>Minimum Card Value</th>
			<th>Active</th>
			<th>Times Used</th>
			<th>POS Item</th>
			<th>Discount Item</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr>
			<td>{{ rec.promoCode }}</td>
			<td>{{ rec.value | currency }}</td>
			<td>
				{{ rec.minimumValue | currency }}
			</td>
			<td>
				<p-inputSwitch (onChange)="savePromoCode(rec)" [(ngModel)]="rec.active"></p-inputSwitch>
			</td>
			<td>
				{{ rec.used }}
			</td>
			<td>
				{{ rec.menuItemName }}
			</td>
			<td>
				{{ rec.discountMenuItemName }}
			</td>
			<td class="d-flex justify-content-end" style="text-align: right">
				<p-button pRipple styleClass="p-button p-button-raised p-button-secondary m-2" (click)="eGiftPromoCodeSelected = rec">
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1"></fa-icon>
					</ng-template>
				</p-button>
			</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog *ngIf="eGiftPromoCodeSelected" header="EGift Promo Code" [(visible)]="eGiftPromoCodeSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }">
	<div class="flex p-grid">
		<div class="p-col">
			<input pInputText type="text" placeholder="Promo Code" name="promoCode" [(ngModel)]="eGiftPromoCodeSelected.promoCode" class="w-100" />
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col">
			<input pInputText type="text" placeholder="Discount Value" name="value" [(ngModel)]="eGiftPromoCodeSelected.value" class="w-100" />
		</div>
		<div class="p-col">
			<input
				pInputText
				type="text"
				placeholder="Minimum Card Value"
				name="minimumValue"
				[(ngModel)]="eGiftPromoCodeSelected.minimumValue"
				class="w-100"
			/>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col">
			<p-dropdown
				placeholder="Select POS Item..."
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="menuItemList"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				[filter]="true"
				filterBy="name, displayName, menuItemKey"
				[(ngModel)]="eGiftPromoCodeSelected.menuItemKey"
				[style]="{ width: '100%' }"
				appendTo="body"
			></p-dropdown>
		</div>
		<!-- <div class="p-col">
            <p-dropdown placeholder="Discount Menu Item" [options]="venueSvc.ooMenuItems" optionLabel="name"
                optionValue="menuItemKey" name="menuItemList" [virtualScroll]="true" virtualScrollItemSize="30" [filter]="true"
                filterBy="name, displayName, menuItemKey" [(ngModel)]="eGiftPromoCodeSelected.discountMenuItemKey"
                [style]="{width: '100%'}" appendTo="body"></p-dropdown>
        </div> -->
	</div>
	<p-footer>
		<p-button pRipple styleClass="p-button-raised m-2" (click)="savePromoCode(eGiftPromoCodeSelected)">
			<ng-template pTemplate="content">
				<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1"></fa-icon>
			</ng-template>
		</p-button>
	</p-footer>
</p-dialog>
